<template>
	<div id="app">
		<router-view></router-view>
	</div>
</template>

<script>
//@import './assets/css/theme/69BAF4/index.css';
//@import './assets/css/theme/D469F4/index.css';
//@import './assets/css/theme/F4C869/index.css';
//@import './assets/css/theme/F46E69/index.css';
  export default{
    name: 'APP',


  }
</script>

<style lang="scss">
  @import './styles/index.scss'; // 全局自定义的css样式
</style>



// WEBPACK FOOTER //
// App.vue?3c096da4